export default __webpack_public_path__ + "/images/gear_head.png";